const AdminDashboard = () => {

    return (
        <div className="">Admin</div>
    )
}

export default AdminDashboard